import React from 'react'
import {PageTitle} from '../../../Molecules/BaseMembersPages/PageTitle'
import {ContentBlock} from '../../../Molecules/BaseContentBlocks/ContentBlock'
import {ContentTitle} from '../../../Molecules/BaseContentBlocks/ContentTitle'
import {ContentTopMessage} from '../../../Molecules/BaseContentBlocks/ContentTopMessage'
import {Spacer} from '../../../../../Common/Components/Spacer'
import {MembersPageTemplate} from '../../../Molecules/BaseMembersPages/MembersPageTemplate'
import {LinkIconText} from '../../../Molecules/LinkIconText'
import {useTranslation} from 'react-i18next'

type AlreadyJoinedContentProps = {
  signboardName: string
  onClick: () => void
}

export const AlreadyJoinedContent: React.VFC<AlreadyJoinedContentProps> = (props) => {
  const {t} = useTranslation('member')

  return (
    <MembersPageTemplate>
      <PageTitle>ご案内</PageTitle>
      <ContentBlock>
        <ContentTitle>{`${t('新規会員情報入力.エラーメッセージ.入会済みコンテンツタイトル')}`}</ContentTitle>
        <ContentTopMessage>
          {`${t('新規会員情報入力.エラーメッセージ.入会済み', {signboardName: props.signboardName})}`}
        </ContentTopMessage>
        <Spacer mt={'18px'} mb={'14px'}>
          <LinkIconText onClick={(): void => props.onClick()}>
            {t('MYアカウント.ページ名')}に移動する
          </LinkIconText>
        </Spacer>
      </ContentBlock>
    </MembersPageTemplate>
  )
}
